/*
SaiKrishna 10/06/2022 3075220937 Removed unnecessary console.log statements
Suresh Peddavoora 10/28/2022 3075220937  Added Class Name for Tatct fields and Button Enhancements
Ashraf 10/30/2022 3075220937 fixed table pagination issue
Ashraf 11/01/2022 3075220937 renamed button labels
Suresh Peddavoora 11/01/2022 3075220937  Changed Positions of Buttons.
Prakash Gummala 11/02/2022 3075220937 Fixed Responsiveness for 768px.
saikrishna 11/03/2022 3075220937 changed the paginationOptions
Lalitha 11/03/2022 3075220937 changed isOutputValues array values Yes to True and No to False and changed labelName
Prakash Gummala 11/07/2022 3075220937 Aligned Table columns width.
Lalitha  11/9/2022  3075220937 Rename Button Clear to Reset
Ashraf  11/10/2022  3075220937 Fixed pagination issue
Ashraf  11/10/2022  3075220937 Fixed pagination rows issue
akhila  11/14/2022  3075220937 fixed vanished account no  bug when we search.
Raghu  11/28/2022  3075220937 Input Field and Table Footer fixes.
Saikrishna  11/29/2022  3075220937 Integrated Test api fr reports filters new design.
Saikrishna  12/01/2022  3075220937 Fixed payload bugs while testing.
Saikrishna  12/02/2022  3075220937 Fixed pagination improper API issue.
Sohel 12/06/2022 3075220937 removed false in Test
rajesh 12/12/2022 3075220937 reset to default value display accounts
akhila 12/20/2022 3075220937 fixed two loaders issue
akhila 12/21/2022 3075220937 fixed reports loading
Lalitha  12/21/2022  3075220937 changed dafault All to True
Sohel 12/22/2022 3075220937 rename Test Button
Suresh Peddavoora 02/09/2023 3075220937 Added Classname for Textfield Enhancements
//suresh peddavoora 03/01/2023 3075220937 new ui changes
Prakash  14-04-2023 3075220937 remove radio  button color
Sohel 06/21/2023 3075220937 Run payload Changes
*/
import React, { useState, useContext, useEffect } from 'react';
// import MaterialTable from "material-table";
import { useDispatch, useSelector } from 'react-redux';
import { tableIcons } from '../../../../../components/TableIcons';
import { Form, Formik } from 'formik';
import {
  FormHelperText,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TablePagination,
} from '@material-ui/core';
import { ThemeContext } from '../../../../../themes/ThemeProvider';
import {
  postReportFilterTest,
  postTestFilterRuleGroup,
  resetTest,
  testFilterResetData,
} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Button, FormControlLabel } from '@material-ui/core';
import * as Yup from 'yup';
import { defaultRows } from '../../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import { tablePageRows } from '../../../../../constants/ReusableConstants';
import PageLoader from '../../../../../components/PageLoader';
const useStyles = makeStyles({
  input: {
    '& .MuiInputBase-formControl': {
      minHeight: '50px !important',
    },
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  border: {
    border: '1px solid gray',
    margin: '0px 2px',
    padding: '4px',
  },
  label: {
    color: 'white',
    padding: '3px',
  },
  radioGroup: {
    border: '1px solid gray',
  },
});
function TestComponent({ testRows, testColumns, passValuesTest, isReportTest, reportId }) {
  const { testFilterResponse, isLoading, errorMsg } = useSelector(
    ({ addRuleGroup }) => addRuleGroup,
  );
  const { reusableInputStyles } = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const useclasses = useStyles();
  const [rows, setRows] = useState(defaultRows);
  const [page, setPage] = useState(0);
  const [filterRuleGroup, setFilterRuleGroup] = useState({});
  const columns = [
    {
      title: 'Result',
      field: 'result',
      minWidth: '100px',
      render: (rowData) => {
        return rowData.fields.result;
      },
    },
    {
      title: 'Account Number',
      field: 'ACCOUNT_NUMBER',
      minWidth: '100px',
      render: (rowData) => {
        return rowData?.fields?.dbacct || rowData?.dbacct
          ? rowData?.fields?.dbacct
          : rowData?.ACCOUNT_NUMBER
            ? rowData?.ACCOUNT_NUMBER
            : '';
      },
    },
    {
      title: 'Fields',
      minWidth: '550px',
      render: (rowData) => {
        const fieldsResult = [];
        for (const [key, value] of Object.entries(rowData.fields)) {
          if (key !== 'dbacct' && key !== 'tableData' && key !== 'result') {
            fieldsResult.push({
              key: key,
              value: value,
            });
          }
        }
        return (
          <div>
            {fieldsResult.map((each, index) => {
              return (
                <span className={useclasses.border} key={index}>
                  {`${each.key} = ${each.value} `}{' '}
                </span>
              );
            })}
          </div>
        );
      },
    },
  ];
  const rows1 = testFilterResponse?.result?.map((each) => {
    return {
      ...each,
      tableData: { checked: true },
    };
  });
  const initialValues = {
    startAccountNo: '',
    evaluateAccountsType: 'True',
  };
  const schema = Yup.object().shape({
    startAccountNo: Yup.number().required('Starting Account Number is required'),
  });

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetTest());
      }, 500);
    }
  }, [errorMsg]);

  const isOutputValues = ['True', 'All'];
  const handleSubmit = (values) => {
    if (passValuesTest?.isReportFilter) {
      const payload = {
        isEvaluateFalse: values.evaluateAccountsType === 'True' ? 'N' : 'Y',
        isEvaluateTrue: values.evaluateAccountsType === 'False' ? 'N' : 'Y',
        limit: 15,
        page: 1,
        reportId: reportId ? reportId : 0,
        reportCode: passValuesTest?.reportCode,
        reportRules: passValuesTest.sqlRules,
        result: passValuesTest?.result,
        sqlRules: passValuesTest.sqlRules.map((each) => {
          return {
            groupCode: '',
            ruleCode: each?.ruleCode,
            sqlCode: each?.sqlExpression,
            id: each?.reportRulesId,
            field: each?.fieldName ? each?.fieldName : '',
            repository: each?.repository ? each?.repository : '',
          };
        }),
        startAccountNo: values.startAccountNo,
      };
      setFilterRuleGroup(payload);

      dispatch(postReportFilterTest(payload));
    } else {
      const testValues = {
        fieldListCode: passValuesTest.fieldListCode,
        result: passValuesTest.result,
        isEvaluateTrue:
          values.evaluateAccountsType === 'All' || values.evaluateAccountsType === 'True'
            ? 'Y'
            : 'N',
        isEvaluateFalse:
          values.evaluateAccountsType === 'All' || values.evaluateAccountsType === 'False'
            ? 'Y'
            : 'N',
        startAccountNo: values.startAccountNo,
        sqlRules: passValuesTest.sqlRules,
        limit: 15,
        page: 1,
      };
      setFilterRuleGroup(testValues);

      dispatch(postTestFilterRuleGroup(testValues));
    }
    setPage(0);
    setRows(15);
  };
  return (
    <div className="col">
      <div>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          // enableReinitialize
        >
          {(props) => {
            const { values, handleChange, handleReset, handleBlur, errors, touched } = props;
            return (
              <Form autoComplete="off" noValidate>
                <div className="form-row global-field-textfields new-standard-textfields">
                  <div className="col-md-6 col-lg-4 form-group">
                    <div className="test-radio-group">
                      <FormLabel
                        component="legend"
                        className={`${classes.radioGroup}  radio-label `}
                      >
                        Display Accounts that Assess
                      </FormLabel>
                      <RadioGroup
                        row
                        name="evaluateAccountsType"
                        id="evaluateAccountsType"
                        defaultValue="All"
                        value={values?.evaluateAccountsType}
                      >
                        {isOutputValues.map((item, i) => (
                          <FormControlLabel
                            key={i}
                            value={item}
                            control={
                              <Radio
                                name="evaluateAccountsType"
                                // checked={values?.evaluateAccountsType === "All"}
                                onChange={handleChange}
                                // onChange={(val) => {
                                //   setFieldValue((values.evaluateAccountsType = item));
                                // }}
                              />
                            }
                            label={item}
                          />
                        ))}
                      </RadioGroup>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 form-group">
                    <TextField
                      className={` ${classes.labelName}`}
                      margin="dense"
                      variant="outlined"
                      placeholder={`Enter Starting Account Number`}
                      label="Starting Account Number"
                      type="number"
                      // className={`${useclasses.input} ${classes.labelName} ${classes.inputLabel}`}
                      name="startAccountNo"
                      value={values.startAccountNo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      required
                      error={Boolean(errors.startAccountNo && touched.startAccountNo)}
                    />
                    <FormHelperText style={{ color: 'red' }}>
                      {touched.startAccountNo && errors.startAccountNo && errors.startAccountNo}
                    </FormHelperText>
                  </div>
                  <div className="col-md-12 col-lg-4 form-group">
                    <div className="d-flex justify-content-md-center justify-content-lg-start">
                      <Button
                        variant="outlined"
                        className={`reset-btn mx-1 ${classes.buttonRoot}`}
                        onClick={() => {
                          handleReset();
                          dispatch(testFilterResetData());
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn mx-1 ${classes.buttonRoot}`}
                      >
                        Run Test
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      <Grid item xs={12} className="">
        <div className="custom-table global-field-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={rows1 ? rows1 : []}
            options={{
              toolbar: false,
              search: false,
              pageSize: rows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            onChangeRowsPerPage={(event) => {
              setRows(event);
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: { 'aria-label': 'Rows per screen' },
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    emptyRowsWhenPaging={false}
                    count={testFilterResponse?.count ? testFilterResponse?.count : 0}
                    rowsPerPageOptions={tablePageRows}
                    rowsPerPage={rows}
                    page={page}
                    onChangePage={(e, pageNumber) => {
                      setPage(pageNumber);
                      if (passValuesTest?.isReportFilter) {
                        dispatch(
                          postReportFilterTest({
                            ...filterRuleGroup,
                            page: pageNumber + 1,
                            limit: rows,
                          }),
                        );
                      } else {
                        dispatch(
                          postTestFilterRuleGroup({
                            ...filterRuleGroup,
                            page: pageNumber + 1,
                            limit: rows,
                          }),
                        );
                      }
                    }}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                      setPage(0);
                      if (passValuesTest?.isReportFilter) {
                        dispatch(
                          postReportFilterTest({
                            ...filterRuleGroup,
                            page: 1,
                            limit: event.target.value,
                          }),
                        );
                      } else {
                        dispatch(
                          postTestFilterRuleGroup({
                            ...filterRuleGroup,
                            page: 1,
                            limit: event.target.value,
                          }),
                        );
                      }
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
      {isLoading && isReportTest && <PageLoader />}
    </div>
  );
}
export default TestComponent;
